import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Breadcrumbs,
  Link,
  Stack,
  Button,
  TextField,
  MenuItem,
  Card,
  CardContent,
} from "@mui/material";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { useNavigate } from "react-router-dom";
import "./backup.css";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { callUnsetApi } from "utils/api";

const Backup = () => {
  const navigate = useNavigate();
  const [dropdownValue, setDropdownValue] = useState("");

  useEffect(() => {
    const userData = sessionStorage.getItem("userData");
    if (!userData) {
      navigate("/");
    } else {
      sessionStorage.setItem("lastVisitedPage", "/backup");
    }
  }, [navigate]);
  const breadcrumbs = [
    <Link></Link>,
    <Typography key="3" sx={{ color: "text.primary" }}>
      Backup
    </Typography>,
  ];
  const siteId = sessionStorage.getItem("selectedSiteId");
  console.log(siteId);

  useEffect(() => {
    return () => {
      callUnsetApi(siteId);
    };
  }, [siteId]);

  const handleSubmit = () => {
    toast.success("Backup Settings are uploading");
    setTimeout(() => {
      window.location.reload();
    }, 10000);
  };

  return (
    <Box m="1.5rem 2.5rem">
      <div className="container-fluid page-body-wrapper">
        <br />
        <br />
        <div className="main-panel">
          <div className="content-wrapper">
            <Stack spacing={2}>
              <Breadcrumbs
                separator={<NavigateNextIcon fontSize="medium" />}
                aria-label="breadcrumb"
              >
                {breadcrumbs}
              </Breadcrumbs>
            </Stack>
            {/* Centered Card */}
            <Box
              display="flex"
              justifyContent="center"
              alignItems="center"
              minHeight="60vh"
            >
              <Card
                sx={{
                  minWidth: 1000,
                  maxWidth: 5500,
                  padding: "2rem",
                  borderRadius: "15px",
                  textAlign: "center",
                  boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.25)",
                  backgroundColor: "#ffffff",
                  animation: "fadeIn 1.5s",
                }}
              >
                <CardContent>
                  <Typography
                    variant="h4"
                    gutterBottom
                    sx={{
                      color: "#997d3d",
                      fontWeight: "bold",
                      mb: 2,
                    }}
                  >
                    Backup Form
                  </Typography>
                  <TextField
                    fullWidth
                    label="Backup URL"
                    variant="outlined"
                    autoComplete="off"
                    margin="normal"
                    required
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        borderRadius: "10px",
                      },
                    }}
                  />
                  <TextField
                    select
                    fullWidth
                    label="Select Option"
                    value={dropdownValue}
                    onChange={(e) => setDropdownValue(e.target.value)}
                    variant="outlined"
                    margin="normal"
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        borderRadius: "10px",
                      },
                    }}
                  >
                    <MenuItem value="Option 1">10 Days</MenuItem>
                    <MenuItem value="Option 2">15 Days</MenuItem>
                    <MenuItem value="Option 3">30 Days</MenuItem>
                    <MenuItem value="Option 3">60 Days</MenuItem>
                    <MenuItem value="Option 3">90 Days</MenuItem>
                  </TextField>
                  <div className="button-upload">
                    <Button class="button-new" onClick={handleSubmit}>
                      <svg xmlns="http://www.w3.org/2000/svg">
                        <rect class="border" pathLength="100"></rect>
                        <rect class="loading" pathLength="100"></rect>

                        <svg
                          class="done-svg"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 24 24"
                        >
                          <path
                            class="done done-cloud"
                            pathLength="100"
                            d="M 6.5,20 Q 4.22,20 2.61,18.43 1,16.85 1,14.58 1,12.63 2.17,11.1 3.35,9.57 5.25,9.15 5.88,6.85 7.75,5.43 9.63,4 12,4 14.93,4 16.96,6.04 19,8.07 19,11 q 1.73,0.2 2.86,1.5 1.14,1.28 1.14,3 0,1.88 -1.31,3.19 Q 20.38,20 18.5,20 Z"
                          ></path>
                          <path
                            class="done done-check"
                            pathLength="100"
                            d="M 7.515,12.74 10.34143,15.563569 15.275,10.625"
                          ></path>
                        </svg>
                      </svg>
                      <div class="txt-upload">Upload</div>
                    </Button>{" "}
                  </div>
                </CardContent>
              </Card>
            </Box>
            <ToastContainer
              position="top-right"
              autoClose={5000}
              hideProgressBar={false}
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
            />
          </div>
        </div>
      </div>
    </Box>
  );
};

export default Backup;
